import React from "react";

import { isAdmin } from "../../../utils/constants";

export default function AdminPageGuard({ children }) {
  if (!isAdmin()) {
    return (
      <div className="loader-center">
        <div className="weight-700 size-16 text-color ">
          You can't access this page
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
